import React, { useEffect, useState } from 'react';
import { Grid, Divider, Typography, TextField, Button, Avatar, MenuItem, ListItemText, createMuiTheme, CircularProgress, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import { Box } from '@mui/material';
import InputMask from 'react-input-mask';
import ConfigDays from './ConfigDays';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    informationHeading: {
        fontSize: 14,
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    TypographyData: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
    },
    TypographyDataLeft: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginLeft: -26
    },
    TextField: {
        width: '100%',
        height: '10%'
    },
    button: {
        margin: 2,
        borderRadius: '50%', // Isso tornará o botão circular
        minWidth: '30px', // Largura mínima do botão
        height: '30px', // Altura do botão para torná-lo um círculo
        color: theme.palette.getContrastText('#4851de'), // Cor do texto
        backgroundColor: '#4851de', // Cor de fundo para botões ativos
        '&:disabled': {
            backgroundColor: theme.palette.action.disabledBackground, // Cor de fundo para botões inativos
        },
        fontFamily: 'montserrat',
        fontWeight: 'bold',
        // marginLeft: -20,
        marginTop: 20
    },
    buttonTwo: {
        borderRadius: '20px', // Isso tornará as bordas do botão arredondadas
        backgroundColor: '#FFFFFF', // Cor de fundo branca
        color: '#4851de', // Cor do texto azul
        border: '2px solid #e0e0e0', // Bordas azuis
        '&:hover': {
            backgroundColor: '#FFFFFF', // Mantém o fundo branco mesmo quando o botão é passado o mouse
        },
        textTransform: 'none',
        marginLeft: 160,
        height: 32,
        marginTop: 112,
        width: 150,
        fontFamily: 'montserrat',
        fontWeight: 'bold',
        fontSize: 12
    },
    buttonTwoUpdate: {
        borderRadius: '20px', // Isso tornará as bordas do botão arredondadas
        backgroundColor: '#FFFFFF', // Cor de fundo branca
        color: '#4851de', // Cor do texto azul
        border: '2px solid #e0e0e0', // Bordas azuis
        '&:hover': {
            backgroundColor: '#FFFFFF', // Mantém o fundo branco mesmo quando o botão é passado o mouse
        },
        textTransform: 'none',
        marginLeft: 238,
        height: 32,
        marginTop: 10,
        width: 75,
        fontFamily: 'montserrat',
        fontWeight: 'bold',
        fontSize: 12
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiInputBase: {
            input: {
                fontSize: 12,
            },
        },
    },
});

const Schedules = ({
    viewEmployeeRegistration,
    isModal
}) => {
    const classes = useStyles()

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Divider style={{ marginTop: -20 }} />
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={5} justify='flex-start' >
                        <Typography className={classes.TypographyDataLeft}>
                            Tipos de Jornada
                        </Typography>
                        <TextField
                            select
                            value={viewEmployeeRegistration.selectedModelSchedule}
                            onChange={viewEmployeeRegistration.handleChangeTypeSchedule}
                            variant="outlined"
                            className={classes.TextField}
                            InputProps={{
                                style: styles.InputLeft
                            }}
                            SelectProps={{
                                style: { ...styles.InputLeft, color: '#434a51', fontFamily: 'montserrat', fontSize: 12 } // Isso mudará a cor do valor selecionado para azul
                            }}
                        >
                            {viewEmployeeRegistration.optionsModel.map((option) => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                >
                                    <ListItemText
                                        primary={option.label}
                                        className={classes.menuItem}
                                        style={{ fontFamily: 'montserrat', fontSize: 12 }}
                                    />
                                </MenuItem>
                            ))}
                        </TextField>
                        <Typography className={classes.TypographyDataLeft}>
                            Data de início
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            type="date"
                            className={classes.TextField}
                            variant="outlined"
                            value={viewEmployeeRegistration.initialDateSchedule}
                            InputProps={{
                                style: styles.InputLeft,
                                inputProps: {
                                    max: "9999-12-31", // Define o valor máximo permitido
                                },
                            }}
                            onChange={event => viewEmployeeRegistration.setinitialDateSchedule(event.target.value)}
                        />

                        <Typography style={{ color: '#464a53', fontFamily: 'montserrat', marginLeft: -20, fontSize: 14, marginTop: 10 }}>
                            Padrão: {
                                (() => {
                                    const schedule = viewEmployeeRegistration.scheduleView.find(schedule => schedule.value == viewEmployeeRegistration.selectedSchedule);
                                    return schedule ? schedule.label : '';
                                })()
                            }
                        </Typography>
                        {
                            viewEmployeeRegistration.updatedHoursSchedule && viewEmployeeRegistration.selectedSchedule == 'scheduleNorm' ||
                                viewEmployeeRegistration.updatedHoursSchedule && viewEmployeeRegistration.selectedSchedule == 'scheduleNormSab' ||
                                viewEmployeeRegistration.updatedHoursSchedule && viewEmployeeRegistration.selectedSchedule == 'rotationsDays'
                                ?
                                // <Grid style={{marginLeft:isModal? -26: 0}}>
                                <ConfigDays viewEmployeeRegistration={viewEmployeeRegistration} isModal={isModal} />
                                // </Grid>
                                :
                                <>
                                    <div style={{ marginLeft: -20, marginTop: 20, position: 'absolute' }}>
                                        {viewEmployeeRegistration.days.map((day, index) => (
                                            <Button
                                                key={day.day}
                                                className={classes.button}
                                                style={{ backgroundColor: day.isWorking ? 'blue' : 'gray' }} // Altera a cor de fundo com base em isWorking
                                                onClick={() => {
                                                    if (viewEmployeeRegistration.updatedHoursSchedule) {
                                                        viewEmployeeRegistration.getDays(true, day.day, viewEmployeeRegistration.selectedSchedule);
                                                    }
                                                }}
                                            >
                                                {day.value}
                                            </Button>
                                        ))}
                                    </div>



                                    <div style={{ display: 'flex', position: 'absolute', height: 0 }}>
                                        <div>
                                            {
                                                viewEmployeeRegistration.updatedHoursSchedule ?

                                                    viewEmployeeRegistration.selectedSchedule == 'flexHours' ?
                                                        <ThemeProvider theme={theme}>
                                                            <div style={styles.horarioContainer}>
                                                                <TextField
                                                                    id="outlined-basic"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    value={viewEmployeeRegistration.horary.firstShiftIni}
                                                                    onChange={event => viewEmployeeRegistration.handleChangeHorary(event, 'firstShiftIni', true)}
                                                                    style={styles.tyleInputFlex}
                                                                    InputProps={{
                                                                        style: {
                                                                            borderRadius: 15
                                                                        },
                                                                        inputComponent: InputMask,
                                                                        inputProps: {
                                                                            mask: '99:99',
                                                                            alwaysShowMask: false,
                                                                        },
                                                                    }}
                                                                />
                                                            </div>
                                                        </ThemeProvider>
                                                        : null
                                                    :
                                                    viewEmployeeRegistration.selectedSchedule == 'flexHours' ?
                                                        <Typography style={styles.horary}
                                                        >
                                                            {viewEmployeeRegistration.formatShiftTime(viewEmployeeRegistration.horary?.firstShiftIni)}
                                                        </Typography>
                                                        :
                                                        <Typography style={styles.horary}>
                                                            {/* {viewEmployeeRegistration.formatShiftTime(viewEmployeeRegistration.horary)} */}
                                                            {viewEmployeeRegistration.groupShiftsByTime(viewEmployeeRegistration.days).sameShifts.map((shift, index) => (
                                                                <div key={index}>{shift}</div>
                                                            ))}
                                                            {viewEmployeeRegistration.groupShiftsByTime(viewEmployeeRegistration.days).differentShifts.map((shift, index) => (
                                                                <div key={index}>{shift}</div>
                                                            ))}
                                                        </Typography>

                                            }
                                            {
                                                viewEmployeeRegistration.selectedSchedule == 'scheduleHours' ? null :
                                                    <Typography style={{
                                                        ...styles.horaryTwo,
                                                        marginTop: viewEmployeeRegistration.selectedSchedule == 'flexHours' ? 18 : 10,
                                                        color: viewEmployeeRegistration.selectedSchedule == 'rotationsDays' || viewEmployeeRegistration.selectedSchedule == 'rotationsHours' ? 'white' : 'black'
                                                    }}>
                                                        Carga horária: {viewEmployeeRegistration.workHours}
                                                    </Typography>
                                            }
                                        </div>
                                    </div>
                                </>
                        }

                        {
                            viewEmployeeRegistration.selectedModelSchedule == 'model' ?
                                <Button
                                    className={viewEmployeeRegistration.updatedHoursSchedule ? classes.buttonTwoUpdate : classes.buttonTwo}
                                    onClick={viewEmployeeRegistration.handleClickUpdateSchedule}>
                                    {viewEmployeeRegistration.updatedHoursSchedule ? 'Salvar' : 'Editar horários'}
                                </Button>
                                :
                                null
                        }

                    </Grid>
                    <Grid item xs={5}>
                        <Typography className={classes.TypographyData}>
                            Modelo
                        </Typography>
                        <TextField
                            select
                            value={viewEmployeeRegistration.selectedSchedule}
                            onChange={viewEmployeeRegistration.handleChangeModelSchedule}
                            variant="outlined"
                            className={classes.TextField}
                            InputProps={{
                                style: styles.InputRight
                            }}
                            SelectProps={{
                                style: { ...styles.InputRight, color: '#434a51', fontFamily: 'montserrat', fontSize: 12 } // Isso mudará a cor do valor selecionado para azul
                            }}
                        >
                            {viewEmployeeRegistration.scheduleView.map((option) => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                >
                                    <ListItemText
                                        primary={option.label}
                                        className={classes.menuItem}
                                        style={{ fontFamily: 'montserrat', fontSize: 12 }}
                                    />
                                </MenuItem>
                            ))}
                        </TextField>

                        <Typography style={{ fontSize: 14, marginTop: 10 }}>
                            {viewEmployeeRegistration.modelsSchedules.find((nameSchedules) => nameSchedules.value == viewEmployeeRegistration.selectedSchedule)?.text}
                        </Typography>
                    </Grid>



                    {/* <Grid xs={5} style={styles.textShceduleOne}>
                        <Typography style={{ fontSize: 14 }}>
                            {viewEmployeeRegistration.modelsSchedules.find((nameSchedules) => nameSchedules.value == viewEmployeeRegistration.selectedSchedule)?.text}
                        </Typography>
                    </Grid> */}

                </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: isModal ? -60 : 0 }}>
                <Divider style={{ marginTop: 10 }} />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={7} container justify="flex-end" style={{ marginLeft: -10, marginTop: isModal ? -37 : 0 }}>
                {
                    viewEmployeeRegistration.loading ?
                        <CircularProgress />
                        :
                        isModal ?
                            <Button style={{
                                ...styles.buttonTwo,
                                backgroundColor: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton || isModal ? '#484fdb' : 'white',
                                color: viewEmployeeRegistration.isUpdate ? 'white' : viewEmployeeRegistration.atualizationButton || isModal ? 'white' : '#c3c3c3'
                            }}
                                onClick={viewEmployeeRegistration.createWorkingDay}
                            >
                                Salvar
                            </Button>
                            :
                            <>
                                <Button
                                    style={{
                                        ...styles.buttonOne,
                                        color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton || isModal ? '#484fdb' : '#c3c3c3'
                                    }}
                                    onClick={() => viewEmployeeRegistration.handleClickDiscard('schedule')}
                                >
                                    Descartar atualizações
                                </Button>
                                <Button style={{
                                    ...styles.buttonTwo,
                                    backgroundColor: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton || isModal ? '#484fdb' : 'white',
                                    color: viewEmployeeRegistration.isUpdate ? 'white' : viewEmployeeRegistration.atualizationButton || isModal ? 'white' : '#c3c3c3'
                                }}
                                    onClick={viewEmployeeRegistration.createWorkingDay}
                                >
                                    {viewEmployeeRegistration.isUpdate? 'Salvar': 'Próximo'}
                                </Button>
                            </>
                }
                {
                    isModal ?
                        null :
                        <>
                            <Box style={styles.Box} />
                            <Avatar style={{ ...styles.avatar }}>
                                <IconButton onClick={() => viewEmployeeRegistration.handleExpandClick('schedule')}
                                    style={{ padding: 0 }}
                                >
                                    <ExpandMoreIcon style={{ fontSize: 20, color: viewEmployeeRegistration.isUpdate ? '#484fdb' : '#c3c3c3' }} />
                                </IconButton>
                            </Avatar>
                        </>
                }
            </Grid>

        </Grid >
    );
};


export default Schedules;

const styles = {
    horarioContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 90,
        marginLeft: -20
    },
    tyleInput: {
        // border: 'none',
        width: '58px',
        height: '20px',
        fontSize: '0.8em',
        borderRadius: 15
    },
    tyleInputFlex: {
        // border: 'none',
        width: '100px',
        height: '20px',
        fontSize: '1em',
        borderRadius: 15
    },
    InputLeft: {
        height: 50,
        padding: '5 14px',
        borderRadius: 10,
        marginLeft: -26,
        overflow: 'hidden',
    },
    InputRight: {
        height: 350,
        padding: '5 14px',
        borderRadius: 10,
        marginRight: -25,
        overflow: 'hidden'
    },
    buttonOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '35%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10,
        textTransform: 'none',
        fontWeight: 'bold'
    },
    buttonTwo: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '16%',
        height: 30,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    Box: { borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px', marginRight: 10 },
    avatar: { backgroundColor: 'white', color: '#c3c3c3', border: '1px solid #c3c3c3', width: 30, height: 30, transform: 'rotate(180deg)' },
    textSchedule: {
        display: 'flex',
        marginLeft: -20,
        // color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 11,
        whiteSpace: 'nowrap',
        marginLeft: 4,
        fontWeight: 'bold'
    },
    textShceduleOne: {
        display: 'flex',
        marginLeft: -20,
        fontFamily: 'montserrat',
        fontSize: 11,
        marginTop: -300,
        marginLeft: 5,
        fontWeight: 'bold'
    },
    textScheduleTwo: {
        display: 'flex',
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 11,
        marginTop: 20,
        whiteSpace: 'nowrap',
        marginBottom: -12,
        marginLeft: 4,
        fontWeight: 'bold'
    },
    scheduleTree: {
        display: 'flex',
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 11,
        marginTop: 20,
        whiteSpace: 'nowrap',
        marginLeft: 4,
        fontWeight: 'bold'
    },
    horary: {
        // display: 'flex',
        marginTop: 90,
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 13,
        marginBottom: -5
    },
    horaryTwo: {
        display: 'flex',
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 13
    }

}
